<div class="container-buttons">
  <ng-template [ngIf]="!isLoading" [ngIfElse]="loading">
    <ng-template [ngIf]="isLogin" [ngIfElse]="not_login">
      <ng-template [ngIf]="
                          purchase?.pdpActionButtonState?.playButtonState?.playButtonMode === playButtonMode.Big ||
                          purchase?.pdpActionButtonState?.playButtonState?.playButtonMode === playButtonMode.DisabledBig">
        <ng-container *ngTemplateOutlet="big_btn"></ng-container>
      </ng-template>
      <ng-template [ngIf]="purchase?.pdpActionButtonState?.showSampleButton">
        <ng-container *ngTemplateOutlet="sample_btn"></ng-container>
      </ng-template>
      <ng-template
        [ngIf]="purchase?.pdpActionButtonState?.playButtonState?.playButtonMode === playButtonMode.SmallWithPlayIcon">
        <ng-container *ngTemplateOutlet="small_subscription_btn"></ng-container>
      </ng-template>
      <ng-template [ngIf]="purchase?.pdpActionButtonState?.showPurchaseButton">
        <ng-container *ngTemplateOutlet="purchase_btn"></ng-container>
      </ng-template>
    </ng-template>
  </ng-template>
</div>

<ng-template #big_btn>
  <button class="button-orange" (click)="goToSubscription()" [class.isPlaying]="isPlaying"
          [class.disabled]="purchase?.pdpActionButtonState?.playButtonState?.playButtonMode === playButtonMode.DisabledBig">
    <span class="icon-navaar-style">
      <navaar-logo-simple-icon></navaar-logo-simple-icon>
    </span>
    <b [textContent]="purchase?.pdpActionButtonState?.playButtonState?.playButtonText"></b>
  </button>
</ng-template>

<ng-template #sample_btn>
  <button (click)="playSample()"
          [style.width.%]="(
                            purchase?.pdpActionButtonState?.showPurchaseButton === false &&
                            purchase?.pdpActionButtonState?.playButtonState?.playButtonMode !== playButtonMode.SmallWithPlayIcon) ||
                            (isLogin === false && appParameterService.clientId === clientType.iGap) ?
                            100 :
                            'inherit'"
          class="button-sample">
    <b>نمونه</b>
  </button>
</ng-template>

<ng-template #purchase_btn>
  <button class="button-purchase btn-color-transparent" (click)="onPurchase()">
    <ng-template [ngIf]="purchase?.discounts?.length > 0" [ngIfElse]="not_discount">
      <b class="wrapper-price">خرید:
        <div class="has-discount">
          <span class="discounted">{{ dataBook.products[0].discountedPrice ? (dataBook.products[0].discountedPrice / 10 | number:'3.0-0') : 'رایگان'}}</span>
          <span class="main-price">{{ dataBook.products[0].price ? (dataBook.products[0].price / 10 | number:'3.0-0') : 'رایگان'}}</span>
        </div>
                               تومان
        <i class="badge-discount-btn">{{ purchase?.discounts[0].discountPercentage * 100 }}&nbsp;%</i>
      </b>
    </ng-template>
    <ng-template #not_discount>
      <b class="wrapper-price">خرید: <span class="without-discount"
                                           [textContent]="dataBook.products[0].price ? (dataBook.products[0].price /10 | number:'3.0-0') : 'رایگان'"></span> تومان</b>
    </ng-template>
  </button>
</ng-template>

<ng-template #small_subscription_btn>
  <button class="button-play btn-color-orange" (click)="onSubscription()">
    <navaar-play-icon>
    </navaar-play-icon>
    <b [textContent]="purchase?.pdpActionButtonState.playButtonState.playButtonText"></b>
  </button>
</ng-template>

<ng-template #not_login>
  <ng-template [ngIf]="dataBook.products[0].price > 0" [ngIfElse]="subscription_small_temp">
    <ng-template [ngIf]="(device.getFeaturesetVersion() >= 2)">
      <button class="button-orange" (click)="goToSubscription()">
      <span class="icon-navaar-style">
        <navaar-logo-simple-icon></navaar-logo-simple-icon>
      </span>
        <b>دریافت رایگان با خرید اشتراک</b>
      </button>
    </ng-template>
  </ng-template>
  <ng-template #subscription_small_temp>
    <button class="button-play btn-color-orange" (click)="purchaseLogoutMode()">
      <navaar-play-icon>
      </navaar-play-icon>
      <b>رایگان بشنوید</b>
    </button>
  </ng-template>
  <ng-container
    *ngTemplateOutlet="appParameterService.clientId !=  clientType.iGap ? purchase_btn_logout : null"></ng-container>
  <ng-container *ngTemplateOutlet="sample_btn"></ng-container>
</ng-template>

<ng-template #loading>
  <navaar-indicator [isShowLoading]="true"></navaar-indicator>
</ng-template>

<ng-template #play_btn>
  <button class="button-play btn-color-orange" [class.isPlaying]="isPlaying"
          [class.disabled]="isLogin ? !purchase : false">
    <navaar-play-icon [show-loader]="showLoaderPlay" [isSmall]="stylePlayerIcon" *ngIf="!isPlaying">
    </navaar-play-icon>
    <b [textContent]="isPlaying ? 'در حال شنیدن' : purchase?.pdpActionButtonState.playButtonState.playButtonText"></b>
  </button>
</ng-template>

<ng-template #purchase_btn_logout>
  <ng-template [ngIf]="dataBook.products[0].price > 0">
    <button class="button-purchase btn-color-transparent" (click)="purchaseLogoutMode()">
      <ng-template [ngIf]="dataBook.products[0].discount !== null" [ngIfElse]="not_discount">
        <b class="wrapper-price">خرید:
          <div class="has-discount">
            <span class="discounted">{{ dataBook.products[0].discountedPrice ? (dataBook.products[0].discountedPrice / 10 | number:'3.0-0') : 'رایگان'}}</span>
            <span class="main-price">{{ dataBook.products[0].price ? (dataBook.products[0].price / 10 | number:'3.0-0') : 'رایگان'}}</span>
          </div>
                                 تومان
          <i class="badge-discount-btn">{{ dataBook.products[0].discount.promotionValue * 100 }}&nbsp;%</i>
        </b>
      </ng-template>
      <ng-template #not_discount>
        <b class="wrapper-price">خرید: <span class="without-discount"
                                             [textContent]="dataBook.products[0].price ? (dataBook.products[0].price / 10 | number:'3.0-0') : 'رایگان'"></span>
                                 تومان</b>
      </ng-template>
    </button>
  </ng-template>
</ng-template>
